import { useContext } from 'react';

import { AuthenticationContext } from './AuthenticationContext';

export const useAuthentication = () => {
  const { user, isLoading, logout } = useContext(AuthenticationContext);

  return { user, isLoading, logout };
};
